import { Injectable } from '@angular/core';
import { getIcon, IconName } from '../components/icon/icons/icon-map';

@Injectable({
  providedIn: 'root',
})
export class IconUtilsService {
  /**
   * Gets the SVG content for the specified icon
   * @param name - The icon name
   * @param size - The icon size in pixels
   * @param color - The icon color
   * @returns The SVG content as string
   */
  getIcon(name: IconName, size: number, color: string): string {
    return getIcon(name, size, color);
  }
}
